<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="等级名称" name="level_name"></c-form-item>
                </c-form>
            </m-search>
            <c-table ref="table" code="growth_level_list">

                <c-table-column
                        label="等级名称"
                        name="level_name"
                        width="150"
                ></c-table-column>

                <c-table-column
                        label="等级徽章"
                        name="level_icon"
                        width="140"
                >
                    <template v-slot="{data}">
                        <c-image :src="data.level_icon" width="78" height="24" :background="false"></c-image>
                    </template>
                </c-table-column>

                <c-table-column
                        label="等级卡片背景图"
                        width="200"
                        v-if="systemConfig.share_enable == 'ON'"
                >
                    <template v-slot="{data}">
                        <c-image :src="data.level_card_img" width="183" height="80" :background="false"></c-image>
                    </template>
                </c-table-column>

                <c-table-column
                        label="成长值门槛"
                        name="level_threshold"
                        width="90"
                ></c-table-column>

                <c-table-column
                        label="权益项数"
                        name="right_count"
                        width="70"
                ></c-table-column>

                <c-table-column
                        label="备注"
                        name="remark"
                        width="250"
                >
                    <template #default="{data}">
                        <span v-if="data.remark">{{ data.remark }}</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        width="120"
                        label="操作"
                >
                    <template v-slot="{data}">
                        <c-table-button @click="levelEdit(data)">查看</c-table-button>
                    </template>
                </c-table-column>
            </c-table>

            <c-dialog ref="editUserLevelDialog" :title="editState ? '编辑代理等级' : '新增代理等级'" width="750"
                      @resolve="submitEditUserLevel">
                <c-form ref="edit_form">
                    <c-form-item type="hidden" name="id"></c-form-item>
                    <c-form-item type="input" label="等级名称" name="level_name" maxlength="30"
                                 word="等级名称只允许包含中文、英文字母、数字、下划线，长度不超过30个字符"></c-form-item>
                    <c-form-item type="number" decimal="0" label="等级折扣" :limit="[1,100]" name="discount" required
                                 word="%（举例：输入80%表示当前等级会员购买商品时，下单价格是商品报价的80%）"></c-form-item>
                    <c-form-item type="image" label="等级徽章" limit="1" name="level_icon" required button
                                 file-word="建议尺寸：240×64像素，格式支持：jpg、png<br><a class='s-link' href='https://cdn.yunchange.com/app_static/psd/%E4%BC%9A%E5%91%98%E5%BE%BD%E7%AB%A0.psd'>下载模板</a>"></c-form-item>
                    <c-form-item v-model="levelColor" type="color" label="徽章文字颜色" name="icon_text_color"
                                 required></c-form-item>
                    <c-form-item type="textarea" label="备注" name="remark" maxlength="150"></c-form-item>
                </c-form>
            </c-dialog>
        </module>
    </page>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: 'm_user_growth',
    computed: {
        ...mapState(['systemConfig'])
    },
    data() {
        return {
            editState: false,
            levelColor: '#FFEBC3'
        }
    },

    mounted() {
        this.$refs.search.search();
        this.$bus.$on('growth_level_list.update', data => {
            // 刷新列表
            this.$refs.table.update();
        });
    },

    methods: {
        searchHandle(data) {
            this.$refs.table.load({
                url: '/growth_level/list',
                data
            });
        },
        //新增等级
        levelEdit(data) {
            if (this.systemConfig.share_enable == 'ON' && data) {//开通分享-编辑
                this.navigateTo(`/growth_level_edit/${data.id}`);
            } else if (this.systemConfig.share_enable == 'ON' && !data) {//开通分享-新增
                this.navigateTo('/growth_level_add');
            } else if (this.systemConfig.share_enable != 'ON' && data) {//未开通分享-编辑
                this.editUserLevel(data);
            } else if (this.systemConfig.share_enable != 'ON' && !data) {
                this.editUserLevel();
            }
        },
        /**打开 新增/编辑 弹窗**/
        editUserLevel(data) {
            //清空表单数据
            this.$refs.edit_form.clear();
            this.$refs.editUserLevelDialog.open();
            if (data) {
                var formData = {};
                formData.id = data.id;
                formData.level_name = data.level_name;
                formData.discount = (data.discount * 100).toFixed(0);
                formData.remark = data.remark;
                formData.level_icon = data.level_icon;
                formData.icon_text_color = data.icon_text_color || this.levelColor;
                this.editState = true;//编辑
                this.$refs.edit_form.set(formData);
            } else {
                this.editState = false;//新增
                var formData = {};
                formData.icon_text_color = this.levelColor;
                this.$refs.edit_form.set(formData);
            }
        },
        /**提交修改**/
        submitEditUserLevel(stop) {
            stop();
            this.$refs.edit_form.submit({
                url: '/growth_level/edit',
                rule: {
                    level_name: '请输入等级名称',
                    level_icon: '请上传等级徽章',
                    discount: '请输入等级折扣'
                },
                success: (data, res) => {
                    //关闭弹窗
                    this.$refs.editUserLevelDialog.close();
                    this.$message({
                        text: '操作成功！'
                    });
                    // 清空表单数据
                    this.$refs.edit_form.clear();
                    this.$refs.search.search();
                }
            });
        },
        //删除会员等级
        removeUserLevel(data) {
            this.$confirm({
                text: '确定要删除【' + data.level_name + '】吗？',
                resolve: () => {
                    this.request({
                        url: '/growth_level/remove',
                        data: {
                            id: data.id
                        },
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '删除成功'
                            });
                            this.$refs.table.update();
                        }
                    });
                }
            });
        }
    }
}
</script>